import type { FC, SVGProps } from 'react';
import { SvgIconComponent } from '@mui/icons-material';
import { Box, SvgIcon, SxProps, Theme } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import TrendingFlatOutlinedIcon from '@mui/icons-material/TrendingFlatOutlined';

function IsMuiIcon(
  icon: SvgIconComponent | FC<SVGProps<SVGElement>>,
): icon is SvgIconComponent {
  return 'muiName' in icon;
}

interface ISwiperTextProps {
  title: string;
  desciption?: string;
  icon?: SvgIconComponent | FC<SVGProps<SVGElement>>;
  viewBox?: string;
  iconSx?: SxProps<Theme>;
  boxSx?: SxProps<Theme>;
  titleSx?: SxProps<Theme>;
  desciptionSx?: SxProps<Theme>;
  handleClick?: () => void;
}

const SwiperText: FC<ISwiperTextProps> = ({
  icon = TrendingFlatOutlinedIcon,
  title,
  titleSx,
  desciption,
  desciptionSx,
  viewBox,
  boxSx,
  iconSx,
  handleClick,
}) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.up('xs'), {
    defaultMatches: true,
  });
  const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  });
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const isLg = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true,
  });

  let weight = 1;
  if (isXs) {
    weight = 2;
  }
  if (isSm) {
    weight = 1.32;
  }
  if (isMd) {
    weight = 1.55;
  }
  if (isLg) {
    weight = 1.45;
  }

  const initIconSx: SxProps<Theme> = {
    fontSize: '20px',
    color: 'inherit',
    fill: IsMuiIcon(icon) ? 'currentColor' : 'none',
  };
  const initBoxSx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '16px',
    gap: 1,
    alignItems: 'flex-start',
    border: '1px solid inherited',
    textAlign: 'left',
    px: 3,
  };

  const initTitleSx: SxProps<Theme> = {
    // fontSize: `${weight * 18}px`,
    fontWeight: 700,
    color: 'inherit',
    lineHeight: 'normal',
    py: 3,
  };

  const initDesciptionSx: SxProps<Theme> = {
    // fontSize: `${weight * 14}px`,
    fontWeight: 400,
    color: 'inherit',
    lineHeight: 'normal',
    pt: 4,
  };

  return (
    <Box sx={{ ...initBoxSx, ...boxSx }} onClick={handleClick}>
      <Box
        sx={{ ...initTitleSx, ...titleSx }}
        fontSize={{
          xs: 24,
          md: 26,
          lg: 28,
        }}
      >
        {title}
      </Box>
      <Box
        sx={{ ...initDesciptionSx, ...desciptionSx }}
        fontSize={{
          xs: 20,
          md: 22,
          lg: 24,
        }}
      >
        {desciption}
      </Box>
      <Box
        sx={{
          position: 'absolute',
          bottom: '8px',
          left: '50%',
          transform: 'translateX(-50%)',
          whiteSpace: 'nowrap',
          fontWeight: 700,
          fontSize: '24px',
        }}
      >
        <SvgIcon
          component={icon}
          inheritViewBox={!viewBox}
          sx={{
            ...initIconSx,
            ...iconSx,
          }}
        />
      </Box>
    </Box>
  );
};

export default SwiperText;
